module.exports = __webpack_public_path__ + "static/iterate-tab-8b7dcffd752d9f7b99d179dec57203ca.png";